export default __webpack_public_path__ + "e488c6a79408004ad09a551bfb3405c7.png";